import React, {useState} from 'react'
import {Button, CircularProgress, Grid, TextField, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {IMAGES_PATH} from "../assets/constants";
import {useMutation} from "react-query";
import {Alert} from "@material-ui/lab";
import apis from "../services";
import {useHistory} from "react-router-dom";
import {setUser} from "../redux/actions";

const useStyles = makeStyles(theme => ({
    container: {
        height: '100vh',
    },
    logo: {
        height: '10em',
        width: '10em',
    },
    labels: {
        marginTop: '1em'
    },
    form: {
        margin: '0 2em'
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: 'bold'
    },
    button: {
        padding: '0.8em 0',
        background: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        },
        color: '#FFF'
    },
    progress: {
        color: '#FFF'
    }
}));

export default function Login({dispatch, updateUser}) {
    const classes = useStyles();
    const history = useHistory();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [helperText, setHelperText] = useState('');
    const [showAlert, setAlert] = useState({content: '', variant: 'error', show: false});

    const {mutate, isLoading} = useMutation('login', apis.userLoginApi,
        {
            onSuccess: ({data}) => {
                if (data?.status) {
                    localStorage.setItem('member', JSON.stringify(data.data));
                    setAlert({...showAlert, content: 'Successfully Logged in', show: true, variant: 'success'})

                    setTimeout(() => {
                        dispatch(setUser(data?.data));
                        updateUser(data?.data);
                        history.push('/');
                    }, [1000]);
                }
            },
            onError: (error) => {
                console.log('ERROR: ', error);
                setAlert({
                    ...showAlert,
                    content: 'Invalid Email or password — check it out!',
                    show: true,
                    variant: 'error'
                })
            }
        })

    //Handle Change Method with Validation
    const handleChange = (event) => {
        let valid;

        switch (event.target.id) {
            case 'Email':
                setEmail(event.target.value);
                valid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value);

                if (!valid) setHelperText('Invalid Email');
                else setHelperText('');
                break;
            default:
                setPassword(event.target.value);
        }
    };
    const closeAlert = () => setAlert({...showAlert, show: false});
    const onSubmit = (event) => {
        event.preventDefault();
        mutate({email, password});
    }

    const success = showAlert.variant === 'success';

    return (
        <Grid container className={classes.container} justify='center' alignItems='center' direction='column'>
            <Grid item> <img className={classes.logo} src={`${IMAGES_PATH}main_logo.jpg`} alt='logo'/></Grid>
            <Grid item>
                <Typography className={classes.title}> Message Center </Typography>
            </Grid>
            <form onSubmit={onSubmit} className={classes.form}>
                <Grid item className={classes.labels}>
                    {showAlert.show && <Alert severity={showAlert.variant} onClose={closeAlert}> {showAlert.content} </Alert>}
                </Grid>
                <Grid item container>
                    <Grid item container className={classes.labels}>
                        <TextField id="Email" placeholder="Email" label="Email" variant="outlined" fullWidth
                                   value={email} onChange={handleChange} helperText={helperText}
                                   error={helperText.length !== 0}/>
                    </Grid>
                    <Grid item container className={classes.labels}>
                        <TextField type={'password'} id="password" label="Password" variant="outlined" fullWidth
                                   value={password} onChange={handleChange}/>
                    </Grid>
                    <Grid item container className={classes.labels}>
                        <Button className={classes.button} variant={"outlined"} size={"large"} fullWidth
                                type={'submit'} disabled={isLoading}>
                            {isLoading || success ? <CircularProgress className={classes.progress} size={30}/> : 'Login'}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Grid>
    )
};